// Core packages
import { Component, Inject, OnInit } from "@angular/core";

// Third party packages
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { take } from "rxjs/operators";

// Custom packages
import { AddCommunicationDialogComponent } from "src/app/shared/components/dialogs/add-communication-dialog/add-communication-dialog.component";

/**
 * Script start
 */
@Component({
  selector: "privacy-docs-qr-code-dialog",
  templateUrl: "./privacy-docs-qr-code-dialog.component.html",
  styleUrls: ["./privacy-docs-qr-code-dialog.component.scss"]
})
export class PrivacyDocsQrCodeDialogComponent implements OnInit {
  qrcodeData = "";
  isQrcode = true;

  /**
   * Class constructor
   */
  constructor(
    public dialogRef: MatDialogRef<PrivacyDocsQrCodeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private translateService: TranslateService,
    private toastrService: ToastrService,
  ) { }

  /**
   * Init components
   *
   * @since 1.0.0
   */
  ngOnInit(): void {
    if (this.data && this.data.data && this.data.data.link) {
      this.qrcodeData = this.data.data.link;
    } else {
      this.isQrcode = false;
    }
  }

  /**
   * Handle dialog closing
   *
   * @since 1.0.0
   */
  onClose(): void {
    this.dialogRef.close();
  }

  /**
   * Handle Qrcode send by email
   *
   * @since 1.0.0
   */
  onSendQrcodeByEmail(): void {
    const qrImage = document
      .getElementById("idQrcodeDataImage")
      .lastElementChild.lastElementChild.getAttribute("src");

    let body = this.translateService.instant('companies.detail.privacyDocsCard.body1');
    body = `${body}\n\n<a href="${this.qrcodeData}">${this.qrcodeData}</a><br>`;
    body = `${body}\n\n${this.translateService.instant('companies.detail.privacyDocsCard.body2')}`;

    // Open dialog
    const newDialogRef = this.dialog.open(
      AddCommunicationDialogComponent,
      {
        minWidth: "60%",
        maxHeight: "98vh",
        data: {
          subject: this.translateService.instant('companies.detail.privacyDocsCard.subject'),
          body,
          qrImage,
        },
        disableClose: true,
      }
    );

    // Subscribe to dialog result (only for 1 emit thanks to "take()")
    newDialogRef
      .beforeClosed()
      .pipe(take(1))
      .subscribe((res) => {
        if (!res) {
          return;
        }
        this.toastrService.success(
          this.translateService.instant("communications.add.sendedSuccessfully")
        );
      });
  }

}
